export default "__VITE_ASSET__BvLmP$xn__"